import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import { ShippingOrder } from '../../DeShippingTableWrapper';

// Utility function to parse location strings
const parseLocationString = (locationStr: string) => {
  const dashIndex = locationStr.indexOf(' - ');
  
  if (dashIndex === -1) {
    return { storeCode: locationStr.trim(), storeName: locationStr.trim() };
  }
  
  const storeCode = locationStr.substring(0, dashIndex).trim();
  const storeName = locationStr.substring(dashIndex + 3).trim();
  
  return { storeCode, storeName };
};

// Main fulfillment location template function
export const OrderFulfillmentLocationTemplate = (rowData: ShippingOrder) => {
  const fulfillmentLocations = rowData.fulfillment_locations;
  
  // Check if fulfillmentLocations is null, undefined, or empty
  if (!fulfillmentLocations || fulfillmentLocations === '' || fulfillmentLocations === '[]') {
    return <span className="text-warning">No location assigned</span>;
  }
  
  let locationsArray: string[] = [];
  
  try {
    // Try to parse as JSON array
    locationsArray = JSON.parse(fulfillmentLocations);
    
    // Ensure it's an array
    if (!Array.isArray(locationsArray)) {
      locationsArray = [fulfillmentLocations];
    }
  } catch (error) {
    // If JSON parsing fails, treat as single location string
    locationsArray = [fulfillmentLocations];
  }
  
  // Filter out empty strings
  locationsArray = locationsArray.filter(loc => loc && loc.trim() !== '');
  
  if (locationsArray.length === 0) {
    return <span className="text-warning">No location assigned</span>;
  }

  // Get unique locations by comparing the full location string
  const uniqueLocations = Array.from(new Set(locationsArray));
  
  if (uniqueLocations.length === 1) {
    // Single unique location - use existing format
    const { storeCode, storeName } = parseLocationString(uniqueLocations[0]);
    
    return (
      <div className="fulfillment-location-info">
        <div className="fw-semibold">{storeName}</div>
        <div className="small text-muted">{storeCode}</div>
      </div>
    );
  }
  
  // Multiple unique locations - show count with tooltip
  const tooltipId = `locations-tooltip-${rowData.order_id}`;
  const tooltipContent = uniqueLocations.map(location => {
    const { storeCode, storeName } = parseLocationString(location);
    return `${storeName} (${storeCode})`;
  }).join('\n');
  
  return (
    <div>
      <span 
        className="fw-semibold text-info"
        data-pr-tooltip={tooltipContent}
        data-pr-position="top"
        data-pr-at="center top-5"
        style={{ cursor: 'pointer', textDecoration: 'underline dotted' }}
        id={tooltipId}
      >
        Assigned to {uniqueLocations.length} stores
      </span>
      <Tooltip target={`#${tooltipId}`} style={{ whiteSpace: 'pre-line' }} />
    </div>
  );
};